import React, { createContext, useContext, useState } from "react";
import {
  returnCurrencyScale,
  returnMarketScale,
} from "@features/MarketOrder/components/MarketCard/SelectDigitalCurrency/Functions/scale";
import { ConstantsContext } from "./constantsContext";

export const MarketContext = createContext();

export const MarketProvider = ({ children }) => {
  const [orderBookClick, setOrderBookClick] = useState(false);
  const [orderType, setOrderType] = useState("");
  const [selectPriceState, setSelectPriceState] = useState({
    unitPrice: 0,
    size: 0,
    total: 0,
  });
  const [forceUpdate, setForceUpdate] = useState(false);
  const [layout, setLayout] = useState("template2");
  const [orderLength, setOrderLength] = useState(0);
  const constants = useContext(ConstantsContext);

  const FirstCurrencyScale = (FirstCurrencyUnit) => {
    return returnCurrencyScale(constants?.orderScaleMap, FirstCurrencyUnit);
  };
  const SecondCurrencyScale = (SecondCurrencyUnit) => {
    return returnMarketScale(
      constants?.marketOrderPriceScaleMap,
      SecondCurrencyUnit
    );
  };

  return (
    <MarketContext.Provider
      value={{
        selectPriceState,
        setSelectPriceState,
        orderBookClick,
        setOrderBookClick,
        orderType,
        setOrderType,
        forceUpdate,
        setForceUpdate,
        layout,
        setLayout,
        orderLength,
        setOrderLength,
        FirstCurrencyScale,
        SecondCurrencyScale,
      }}
    >
      {children}
    </MarketContext.Provider>
  );
};
